module.exports = __webpack_public_path__ + "static/media/pen-and-paper.fcc5192d.jpg";